/**
 * 主题封面组件
 */
import {useEffect, useRef, useState, useCallback} from 'react';
import * as store from '@/store';
import {getMorphoService, serviceNames} from '@/rte/editor';
import ThemeCoverSvg from '@/assets/svg/ai/themeCover.svg?tsx';
import Tooltip, {TooltipTrigger} from '@/components/Tooltip';
import {Popper, PopperTrigger} from '@baidu/luffy-comp-popper';
import {useIntl} from 'react-intl';
import Icon from '@/components/Icon';
import {DocWordCloseSvg, ArrowRightSvg} from '@/icons';
import sdk from '@/sdk';
import classNames from 'classnames';

import styles from './index.module.scss';

interface IProps {
    isHover: boolean;
    docGuid: string;
    showSlideCover?: boolean;
    isCoverApplied?: boolean;
    isCardView?: boolean;
    setShowPopup?: (val: boolean) => void;
    setIsHover?: (val: boolean) => void;
}

interface INewGuide{
    onClose:()=>void;
}

const NewGuide:React.FC<INewGuide> = ({onClose: handleClose}) => {
    const intl = useIntl();
    return (
        <div className={styles.guideRoot} onClick={(ev: React.MouseEvent<HTMLDivElement>) => ev.stopPropagation()}>
            <div className={styles.guideWord}>可以在这更换主题、恢复封面设置</div>
            <div onClick={handleClose}>
                <Icon svg={DocWordCloseSvg} />
            </div>
        </div>
    );
};

const ThemeCover: React.FC<IProps> = ({
    isHover,
    setShowPopup,
    showSlideCover = true,
    isCardView = false,
    isCoverApplied = false,
    setIsHover,
}) => {

    const [tooltipVisible, setTooltipVisible] = useState(false);
    const [guideVisible, setGuideVisible] = useState(false);
    const target = useRef<any>();
    const [isShowEntry, setIsShowEntry] = useState(false);
    const textDom = useRef<any>();

    const onChange = (visible: boolean) => {
        setTooltipVisible(visible);
        // 弹窗隐藏后需要恢复父元素的onMouseLeave事件
        setShowPopup && setShowPopup(visible);
    };

    const handleCloseGuide = useCallback(() => {
        setGuideVisible(false);
        sdk.as.updateNewGuide({
            hideHeaderImage: true,
        }).catch(err => console.error(err));
    }, []);

    const onClose = () => {
        // setTimeout(() => {
        //     setTooltipVisible(false);
        // }, 50);
    };

    useEffect(() => {
        try {
            const editorStateService = getMorphoService(serviceNames.IEditorStateService);
            if (editorStateService && tooltipVisible) {
                const {MorphoAPI} = editorStateService?.editor || {};
                const popupDom = MorphoAPI.getCoverPopupDom(editorStateService?.editor, textDom.current, onClose);
            }
        }
        catch (error) {
            console.error(error, '------');
        }
    }, [tooltipVisible]);


    const handleClick = () => {
        setTooltipVisible(true);
        // 点击按钮后弹窗显示，hover到弹窗后避免执行父元素onMouseLeave事件,导致当前元素和弹窗隐藏
        setShowPopup && setShowPopup(true);
        // 点击后关闭新手引导弹窗
        guideVisible && handleCloseGuide();
    };

    const render = () => {
        return <div ref={textDom}></div>;
    };

    useEffect(() => {
        if (!window.isTocPage) {
            setTimeout(() => {
                setGuideVisible(!sdk.as.user?.settings?.newGuide?.hideHeaderImage && !showSlideCover);
            }, 100);
        }
    }, [showSlideCover]);

    useEffect(() => {
        // 切换封面后，弹窗隐藏，父元素的onMouseLeave事件正常执行,
        if (showSlideCover) {
            setIsHover && setIsHover(false);
            setShowPopup && setShowPopup(false);
            setTooltipVisible(false);
        }
    }, [showSlideCover, setShowPopup, setIsHover]);

    useEffect(() => {
        // 有新手引导的时候直接展示按钮，没有新手引导的话需要hover后才显示按钮
        if (guideVisible && !showSlideCover) {
            setIsShowEntry(true);
        } else {
            setIsShowEntry(!showSlideCover && isCardView && isHover);
        }

    }, [showSlideCover, isCardView, guideVisible, isHover]);

    useEffect(() => {
        // 应用封面后需关闭弹窗和隐藏按钮
        if (isCoverApplied) {
            setTooltipVisible(false);
            setIsHover && setIsHover(false);
            setShowPopup && setShowPopup(false);
            store.setIsCoverApplied(false);
        }
    }, [isCoverApplied, setShowPopup, setIsHover]);

    return (
        <div className={styles.wrapperBox}>
            {isShowEntry &&
                <PopperTrigger visible={guideVisible && !showSlideCover} target={target.current}>
                    <Tooltip
                        trigger={TooltipTrigger.Click}
                        content={render()}
                        visible={tooltipVisible}
                        onChange={onChange}
                        className={styles.tooltip}
                    >
                        <div className={styles.wrapper} onClick={handleClick} ref={target}>
                            <ThemeCoverSvg className={styles.icon} />
                            <div className={styles.text}>主题封面</div>
                            <Icon
                                className={classNames(
                                    styles.arrow,
                                    tooltipVisible && styles.iconActive
                                )}
                                svg={ArrowRightSvg}
                            />
                        </div>
                    </Tooltip>
                    {
                        !window.isTocPage && <Popper
                            className={styles.countPopover}
                            withArrow
                            placement={'top'}
                        >
                            <NewGuide onClose={handleCloseGuide} />
                        </Popper>
                    }
                </PopperTrigger>
            }
        </div>
    );
};

export default store.connect([
    store.KEYS.SHOW_SLIDE_COVER,
    store.KEYS.IS_COVER_APPLIED,
])(ThemeCover);
